import { useQuery } from '@tanstack/react-query';
import { api } from './client';
export function useGetPublicPlayer(playerId) {
    return useQuery({
        queryKey: ['public', 'players', playerId],
        queryFn: () => api.request(`/api/public/players/${playerId}`),
        enabled: playerId > 0,
        staleTime: 30_000,
    });
}
export function useGetPlayerEloHistory(playerId) {
    return useQuery({
        queryKey: ['public', 'players', playerId, 'elo-history'],
        queryFn: () => api.request(`/api/public/players/${playerId}/elo-history`),
        enabled: playerId > 0,
        staleTime: 30_000,
    });
}
